import Idea from "./idea";
import { useAppSelector } from "@/redux/store/hooks";
import { Box } from "@/storybook-components";

const Banner = () => {
  const { brainstormers } = useAppSelector((state) => state.brainstormers);

  return (
    <Box
      as="ul"
      listStyleType="none"
      display="flex"
      flexDirection="column"
      gap={3}
      m={0}
      p={0}
    >
      {[...brainstormers]
        .sort((a, b) => a.sequence - b.sequence)
        .map((brainstormer) => (
          <Box
            as="li"
            listStyleType="none"
            key={brainstormer.id}
            border="1px solid #ececec"
            bg="white"
            borderRadius="md"
            overflow="hidden"
          >
            <Idea brainstormer={brainstormer} />
          </Box>
        ))}
    </Box>
  );
};

export default Banner;
